import React from 'react';
import * as e from '../elements';

export default {
  name: 'Text Cover',
  description: 'Basic cover with just your product name and slogan',
  thumb: 'cover-text',
  tags: ['Cover'],
  jsx: (
    <e.PBlock pad="hi" >
      <div className="row align-items-center">
        <div className="col-12 col-md-10 col-lg-8 mx-auto text-center">
          <e.PText
            size="header-h1"
            color="primary"
            className="my-3"
            text="Our Company"
          />
          <e.PText
            text="Our motto, in a single line."
            color="black-md"
            size="header-h3"
            className="my-3"
          />
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverText.jsx